import React, { useContext } from "react";
import { Row, Col, Form } from "react-bootstrap";
import PsContext from "../../../context/PsContext";
import USER from "../../../assets/img/user.png";
import { Link } from "react-router-dom";

const MyProfile = () => {
  const context = useContext(PsContext);

  return (
    <div style={{ backgroundColor: " #e3e3e3;" }}>
      <div className="container mt-4">
        <Row>
          <Col md={3} className="sidebars">
            <div
              className="border-bottom bb"
              style={{
                background: "#fff",
              }}
            >
              <div className="d-flex align-items-center ms-10 py-1">
                <img
                  src={USER}
                  alt="User"
                  width="40"
                  height="40"
                  className="me-2"
                />
                <div className="fw-bold ms-10">
                  Welcome Back,{" "}
                  <span style={{ fontWeight: "700" }}>
                    {" "}
                    {context.state.userData.contactname || ""}
                  </span>
                </div>
              </div>
            </div>

            <div className="menu-section ms-10">
              <Link to="/user/my-orders" className="menu-link">
                <i
                  className="fas fa-truck me-2"
                  style={{ color: "#f58b76" }}
                ></i>
                <span className="ms-10">My Orders</span>
                {/* <span style={{ marginLeft: "130px" }}>
                  {" "}
                  <i class="fa fa-angle-right tf-md-hidden"></i>
                </span> */}
              </Link>
            </div>

            <div className="menu-section ms-10">
              <h6>ACCOUNT SETTINGS</h6>
              <Link to="/wishlist" className="menu-link">
                <i
                  class="icon icon-heart me-2"
                  style={{ color: "#f58b76" }}
                ></i>{" "}
                My Wishlist
                {/* <span style={{ marginLeft: "130px" }}>
                  {" "}
                  <i class="fa fa-angle-right tf-md-hidden"></i>
                </span> */}
              </Link>
              <Link to="/viewcart" className="menu-link">
                <i
                  className="fas fa-shopping-cart me-2"
                  style={{ color: "#f58b76" }}
                />{" "}
                View Cart
                {/* <span style={{ marginLeft: "140px" }}>
                  {" "}
                  <i class="fa fa-angle-right tf-md-hidden"></i>
                </span> */}
              </Link>
            </div>
          </Col>

          {/* Profile Content */}
          <Col md={9} className="profile-content">
            <h5 className="text-center">Personal Information</h5>
            <Form className="mt-3">
              <Row className="mb-3">
                <Col md={12}>
                  <h5 className="section-title">Name</h5>
                  <Form.Control
                    type="text"
                    value={context.state.userData.contactname || ""}
                    readOnly
                  />
                </Col>
                {/* <Col md={6}>
                  <Form.Control type="text" value="" readOnly />
                </Col> */}
              </Row>

              {/* <div className="mb-4">
                <div>Your Gender</div>
                <Form.Check
                  inline
                  label="Male"
                  type="radio"
                  name="gender"
                  disabled
                />
                <Form.Check
                  inline
                  label="Female"
                  type="radio"
                  name="gender"
                  disabled
                />
              </div> */}
              <Row>
                <Col md={6}>
                  <h5 className="section-title">Email Address</h5>
                  <Form.Control
                    className="mb-4"
                    type="email"
                    value={context.state.userData.email || ""}
                    readOnly
                  />
                </Col>

                <Col md={6}>
                  <h5 className="section-title">Mobile Number</h5>
                  <Form.Control
                    type="text"
                    value={context.state.userData.mobile || ""}
                    readOnly
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MyProfile;
